import * as Yup from 'yup'
import { documentDetailSearchFields, documentFields } from './fields'

export const documentValidation = (data) => {
    const isEdit = data?.id ? true : false
    const currentLang = localStorage.getItem('i18nextLng') || 'hr'

    // only one of project/property/contact is ever enabled at a time (the other two are disabled — see documentFieldTypes),
    // so the same parent internalAppId feeds whichever one of the three fields actually applies
    const parentInternalAppId = data?.parentInternalAppId ?? data?.parentElement?.element?.internalAppId

    return {
        initialValues: {
            ...(isEdit && { id: data?.id ?? '' }),
            ...(isEdit && {
                file_description: data?.translations?.[currentLang]?.fileDescription ?? data?.translations?.hr?.fileDescription ?? '',
            }),
            [documentFields.DOCUMENT_PROJECT_INTERNAL_APP_ID]: data?.module === 'project' ? parentInternalAppId ?? '' : '',
            [documentFields.DOCUMENT_PROPERTY_INTERNAL_APP_ID]: data?.module === 'property' ? parentInternalAppId ?? '' : '',
            [documentFields.DOCUMENT_CONTACT_ID]: data?.module === 'contact' ? parentInternalAppId ?? '' : '',
            [documentFields.DOCUMENT_TYPE]: data?.documentType?.id?.toString() ?? '',
            [documentFields.DOCUMENT_CREATION_DATE]: data?.documentCreationDate ?? '',
            [documentFields.DOCUMENT_VALIDITY_DATE]: data?.documentValidityDate ?? '',
            [documentFields.FILE_SYNC]: data?.fileSync ?? false,
        },
        validationSchema: Yup.object({}),
    }
}

export const documentsDetailSearchValidation = (data) => ({
    initialValues: {
        [documentDetailSearchFields.FILE_DESCRIPTION]: data?.[documentDetailSearchFields.FILE_DESCRIPTION] ?? '',
        [documentDetailSearchFields.DOCUMENT_PROPERTY_ID]: data?.[documentDetailSearchFields.DOCUMENT_PROPERTY_ID] ?? '',
        [documentDetailSearchFields.DOCUMENT_PROJECT_ID]: data?.[documentDetailSearchFields.DOCUMENT_PROJECT_ID] ?? '',
        [documentDetailSearchFields.DOCUMENT_CONTACT_ID]: data?.[documentDetailSearchFields.DOCUMENT_CONTACT_ID] ?? '',
        [documentDetailSearchFields.DOCUMENT_TYPE]: data?.[documentDetailSearchFields.DOCUMENT_TYPE] ?? '',
        [documentDetailSearchFields.DOCUMENT_CREATION_DATE_FROM]: data?.[documentDetailSearchFields.DOCUMENT_CREATION_DATE_FROM] ?? '',
        [documentDetailSearchFields.DOCUMENT_CREATION_DATE_TO]: data?.[documentDetailSearchFields.DOCUMENT_CREATION_DATE_TO] ?? '',
        [documentDetailSearchFields.DOCUMENT_VALIDITY_DATE_FROM]: data?.[documentDetailSearchFields.DOCUMENT_VALIDITY_DATE_FROM] ?? '',
        [documentDetailSearchFields.DOCUMENT_VALIDITY_DATE_TO]: data?.[documentDetailSearchFields.DOCUMENT_VALIDITY_DATE_TO] ?? '',
    },
    validationSchema: Yup.object({}),
})
